import type { FieldInputValue, Option } from './types';

/** Strips a control's own chrome so it sits flush inside a joined card. */
export const flushClassName = 'rounded-none border-0 bg-transparent shadow-none ring-inset';

/** Present = non-empty string/array or any other defined value. */
export const isValuePresent = (value: unknown): boolean => {
  if (value === undefined || value === null) {
    return false;
  }
  if (typeof value === 'string' || Array.isArray(value)) {
    return value.length > 0;
  }
  return true;
};

export const asString = (value: FieldInputValue): string =>
  typeof value === 'string' ? value : '';

export const asStringArray = (value: FieldInputValue): string[] =>
  Array.isArray(value) ? value : [];

/**
 * Resolves an option's display label. base-ui hands this either a selected
 * string value (the combobox value is a string) or a whole option object (while
 * filtering the `items` list), so it accepts both and falls back to the value.
 */
export const optionLabel = (options: Option[], item: unknown): string => {
  if (typeof item === 'string') {
    return options.find((option) => option.value === item)?.label ?? item;
  }
  if (item && typeof item === 'object' && 'label' in item) {
    return String((item as Option).label);
  }
  return '';
};
